<script>
export default {
    functional: true,
    props: ['menuOpened', 'submenuOpened', 'tabindex'],
    render(h, ctx) {

        const Button = h('button', {
            class: {
                'main-menu__trigger': true,
                '-open': ctx.props.menuOpened,
                '-submenu': ctx.props.submenuOpened,
            },
            attrs: {
                'aria-label': ctx.props.menuOpened ? 'Close main menu' : 'Open main menu',
                tabindex: ctx.props.menuOpened ? 1 : ctx.props.tabindex,
                ...ctx.data.attrs,
            },
            on: {
                click: () => ctx.parent.$root.$emit('toggle-menu'),
                focus: (e) => {

                    if (ctx.props.menuOpened && e.target !== document.activeElement) {
                        document.querySelector('.wrapper--nav .main-menu__nav-item').focus()
                    }
                }
            },
            domProps: {
                innerHTML: `<div class=icon />`
            }
        })

        return h('div', {
            class: 'wrapper--menu-buttons has-overflow',
        }, [Button])
    }
}
</script>